export default {
  header: 'Bestellübersicht',
  buttons: {
    checkout: 'Sicher zur Kasse',
    continue: 'Weiter',
    menu: 'Menü',
  },
  empty_order_basket: {
    description: 'Dein Warenkorb ist leer <br/> Artikel hinzufügen, um loszulegen',
  },
  promo_code_banner: {
    single_use: '{{discount}} Rabatt - {{code}}',
    multi_use: '{{discount}} Rabatt auf {{count}} Bestellungen - {{code}}',
    redeem: 'ANWENDEN',
    redeemed: 'EINGELÖST',
  },
  upsell: {
    title: 'Kunden bestellen ebenfalls',
  },
  rewards: {
    title: 'Zahle mit Punkten',
    description: '<highlight>Anmelden</highlight> um mit Punkten zu zahlen',
  },
};
